import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import EnhancedTable from './tableOperation/EnhancedTable';
import { getOperation } from './operationsActions';
import { Title } from '../style';
import { commandsReport } from '../exportCommands/exportCommandsActions';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Operation = ({
  dispatchGetOperation,
  customerOperation,
  dispatchCommandsReport
}) => {
  const { operationId } = useParams();

  useEffect(() => {
    dispatchGetOperation(operationId);
  }, [dispatchGetOperation, operationId]);

  /**
   * Création de l'objet data permettant de
   * récupéré le fichier d'export
   */
  const handleClick = () => {
    dispatchCommandsReport({
      operationNumber: customerOperation.id
    });
  };

  return (
    <>
      <Container>
        <Title>Opération n° {operationId}</Title>
      </Container>
      <EnhancedTable
        customerOperation={customerOperation}
        exportOperation={handleClick}
      />
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  dispatchGetOperation: params => dispatch(getOperation(params)),
  dispatchCommandsReport: data => dispatch(commandsReport(data))
});

const mapStateToProps = state => ({
  customerOperation: state.operations.customerOperation
});

Operation.propTypes = {
  dispatchCommandsReport: PropTypes.func.isRequired,
  dispatchGetOperation: PropTypes.func.isRequired,
  customerOperation: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Operation);
